import { ActivityStatusDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { ActivityStatus } from '@/services/graphql/types';

export const mapperToActivityStatusDataEnum = createEnumMapperFunction(
  ActivityStatus,
  ActivityStatusDataEnum
);
